import { useSetAtom } from "jotai";
import { useCallback, useMemo } from "react";
import { visitorIsHelpModalOpenAtom } from "../state";
import {
  isAdmissionModalOpenAtom,
  isProviderNotHereModalOpenAtom,
} from "../waiting-room/admission/state";

export enum Modal {
  HELP = "HELP",
  PROVIDER_NOT_HERE = "PROVIDER_NOT_HERE",
  ADMISSION = "ADMISSION",
}

/**
 * Ideally we'd refactor visitor state to have a single modal state atom, but
 * for now this can be used to open one modal at a time. Closes modal(s) when
 * called with `null` argument.
 */
export function useOpenVisitorModalCallback() {
  const setIsHelpModalOpen = useSetAtom(visitorIsHelpModalOpenAtom);
  const setIsProviderNotHereModalOpen = useSetAtom(
    isProviderNotHereModalOpenAtom,
  );
  const setIsAdmissionModalOpen = useSetAtom(isAdmissionModalOpenAtom);
  const isModalOpenSetters = useMemo<Record<Modal, (isOpen: boolean) => void>>(
    () => ({
      [Modal.HELP]: setIsHelpModalOpen,
      [Modal.PROVIDER_NOT_HERE]: setIsProviderNotHereModalOpen,
      [Modal.ADMISSION]: setIsAdmissionModalOpen,
    }),
    [
      setIsHelpModalOpen,
      setIsProviderNotHereModalOpen,
      setIsAdmissionModalOpen,
    ],
  );

  return useCallback(
    (modal: Modal | null) => {
      for (const [key, setIsOpen] of Object.entries(isModalOpenSetters)) {
        if (key === modal) {
          setIsOpen(true);
        } else {
          setIsOpen(false);
        }
      }
    },
    [isModalOpenSetters],
  );
}
